import React from 'react';

const PremiumLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-6 p-8">
      <div className="relative w-20 h-20">
        {/* Soft background ring */}
        <div className="absolute inset-0 rounded-full border-[3px] border-secondary/10"></div>
        {/* Spinning primary ring */}
        <div className="absolute inset-0 rounded-full border-[3px] border-secondary border-t-transparent animate-spin" style={{ animationDuration: '1.5s' }}></div>
        {/* Inner spinning ring */}
        <div className="absolute inset-2 rounded-full border-[2px] border-primary/20 border-b-transparent animate-spin" style={{ animationDuration: '1s', animationDirection: 'reverse' }}></div>
        {/* Core pulsing diamond */}
        <div className="absolute inset-0 m-auto w-4 h-4 bg-secondary rotate-45 animate-pulse shadow-[0_0_15px_rgba(117,91,0,0.4)]"></div>
      </div>
      <div className="font-body-strong text-secondary tracking-[0.3em] text-[10px] uppercase animate-pulse">
        Processing
      </div>
    </div>
  );
};

export default PremiumLoader;
